import { useQuery } from 'react-query';
import { network } from 'services/network';

import { QueryKeys } from 'api/queryKeys';

import { CompareOptions } from 'components/Dashboards/ExcellenceApps/ClusterRCFAnalysis/CompareTo/CompareTo';

const queryFn = (params: QueryParams) => {
    return network
        .post('api/bo/getClustersList', {
            paFileMetaDataIds: params.idList,
            projectId: params.projectId,
            clusterType: params.compare,
        })
        .then((response) => {
            return response.data;
        });
};
export const useQueryClustersList = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['clustersList', params],
        queryFn: () => queryFn(params),
        enabled: params.idList.length > 0 && Boolean(params.compare),
        staleTime: 300000,
    });
};

interface QueryParams {
    idList: number[];
    projectId: number | undefined;
    compare: CompareOptions;
}

export interface QueryResponse {
    clusterList: {
        clusterId: number;
        clusterName: string;
        completedDurationHigh: number | null;
        completedDurationTypical: number | null;
        completedOverrunDaysHigh: number | null;
        completedOverrunDaysTypical: number | null;
        completedOverrunRatioHigh: number | null;
        completedOverrunRatioTypical: number | null;
        fileMetaData: number | null;
        plannedDurationHigh: number | null;
        plannedDurationTypical: number | null;
    }[];
}
